import React from 'react';

import { clsx } from 'clsx';

import styles from './Input.scss';

type InputProps = React.ComponentProps<'input'> & {
  variant?: 'default' | 'danger';
  inputClassName?: string;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ placeholder, className, inputClassName, variant, ...props }, ref) => {
    return (
      <div className={clsx(styles.container, className)}>
        <input
          ref={ref}
          className={clsx(styles.input, variant === 'danger' && styles.inputDanger, inputClassName)}
          placeholder={placeholder}
          {...props}
        />

        {placeholder && <span className={styles.label}>{placeholder}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
